module.exports = __webpack_public_path__ + "static/media/IMG_20201031_0007.4f50917c.jpg";